// CANONICAL COPY (GH #7115). src/constants/frameworks/pciDss.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

const FRAMEWORK_PCI_DSS = {
  id: 'fw-pci-dss',
  type: 'standard',
  name: 'PCI DSS v4.0',
  shortName: 'PCI DSS',
  abbrev: 'PCIDSS',
  description:
    'Payment Card Industry Data Security Standard — security requirements for all entities that store, process, or transmit cardholder data and/or sensitive authentication data.',
  color: '#f59e0b',
  version: '4.0',
  sectionKeyDepth: 1,
  // The twelve PCI DSS requirements, as named in the mapping headings below.
  sections: [
    { key: '1', name: 'Requirement 1 — Network Security Controls' },
    { key: '2', name: 'Requirement 2 — Secure Configurations' },
    { key: '3', name: 'Requirement 3 — Protect Stored Account Data' },
    { key: '4', name: 'Requirement 4 — Protect Cardholder Data in Transit' },
    { key: '5', name: 'Requirement 5 — Protect Systems from Malicious Software' },
    { key: '6', name: 'Requirement 6 — Develop and Maintain Secure Systems' },
    { key: '7', name: 'Requirement 7 — Restrict Access to System Components and Cardholder Data' },
    { key: '8', name: 'Requirement 8 — Identify Users and Authenticate Access' },
    { key: '9', name: 'Requirement 9 — Restrict Physical Access to Cardholder Data' },
    { key: '10', name: 'Requirement 10 — Log and Monitor All Access' },
    { key: '11', name: 'Requirement 11 — Test Security of Systems and Networks' },
    { key: '12', name: 'Requirement 12 — Support Information Security with Policies' },
  ],
  mappings: [
    // ── Requirement 1 — Network Security Controls ───────────────────────
    { externalId: 'PCI-1.1', scfId: 'SCF-NET-001', ref: 'Req 1.1' },
    { externalId: 'PCI-1.2', scfId: 'SCF-NET-001', ref: 'Req 1.2' },
    { externalId: 'PCI-1.3', scfId: 'SCF-NET-003', ref: 'Req 1.3' },
    { externalId: 'PCI-1.4', scfId: 'SCF-NET-002', ref: 'Req 1.4' },
    { externalId: 'PCI-1.5', scfId: 'SCF-OPS-001', ref: 'Req 1.5' },

    // ── Requirement 2 — Secure Configurations ───────────────────────────
    { externalId: 'PCI-2.1', scfId: 'SCF-OPS-005', ref: 'Req 2.1' },
    { externalId: 'PCI-2.2', scfId: 'SCF-OPS-005', ref: 'Req 2.2' },
    { externalId: 'PCI-2.3', scfId: 'SCF-NET-001', ref: 'Req 2.3' },

    // ── Requirement 3 — Protect Stored Account Data ─────────────────────
    { externalId: 'PCI-3.1', scfId: 'SCF-DAT-001', ref: 'Req 3.1' },
    { externalId: 'PCI-3.2', scfId: 'SCF-DAT-003', ref: 'Req 3.2' },
    { externalId: 'PCI-3.3', scfId: 'SCF-DAT-003', ref: 'Req 3.3' },
    { externalId: 'PCI-3.4', scfId: 'SCF-DAT-004', ref: 'Req 3.4' },
    { externalId: 'PCI-3.5', scfId: 'SCF-NET-005', ref: 'Req 3.5' },
    { externalId: 'PCI-3.6', scfId: 'SCF-NET-005', ref: 'Req 3.6' },
    { externalId: 'PCI-3.7', scfId: 'SCF-NET-005', ref: 'Req 3.7' },

    // ── Requirement 4 — Protect CHD in Transit ──────────────────────────
    { externalId: 'PCI-4.1', scfId: 'SCF-NET-005', ref: 'Req 4.1' },
    { externalId: 'PCI-4.2', scfId: 'SCF-NET-005', ref: 'Req 4.2' },

    // ── Requirement 5 — Protect Systems from Malicious Software ─────────
    { externalId: 'PCI-5.1', scfId: 'SCF-OPS-003', ref: 'Req 5.1' },
    { externalId: 'PCI-5.2', scfId: 'SCF-OPS-003', ref: 'Req 5.2' },
    { externalId: 'PCI-5.3', scfId: 'SCF-OPS-003', ref: 'Req 5.3' },
    { externalId: 'PCI-5.4', scfId: 'SCF-NET-004', ref: 'Req 5.4' },

    // ── Requirement 6 — Develop and Maintain Secure Systems ─────────────
    { externalId: 'PCI-6.1', scfId: 'SCF-DEV-001', ref: 'Req 6.1' },
    { externalId: 'PCI-6.2', scfId: 'SCF-DEV-004', ref: 'Req 6.2' },
    { externalId: 'PCI-6.3', scfId: 'SCF-OPS-004', ref: 'Req 6.3' },
    { externalId: 'PCI-6.4', scfId: 'SCF-DEV-011', ref: 'Req 6.4' },
    { externalId: 'PCI-6.5', scfId: 'SCF-DEV-008', ref: 'Req 6.5' },

    // ── Requirement 7 — Restrict Access to System Components and CHD ─────
    { externalId: 'PCI-7.1', scfId: 'SCF-IAM-001', ref: 'Req 7.1' },
    { externalId: 'PCI-7.2', scfId: 'SCF-IAM-006', ref: 'Req 7.2' },
    { externalId: 'PCI-7.3', scfId: 'SCF-IAM-004', ref: 'Req 7.3' },

    // ── Requirement 8 — Identify Users and Authenticate Access ──────────
    { externalId: 'PCI-8.1', scfId: 'SCF-IAM-002', ref: 'Req 8.1' },
    { externalId: 'PCI-8.2', scfId: 'SCF-IAM-003', ref: 'Req 8.2' },
    { externalId: 'PCI-8.3', scfId: 'SCF-IAM-008', ref: 'Req 8.3' },
    { externalId: 'PCI-8.4', scfId: 'SCF-IAM-008', ref: 'Req 8.4' },
    { externalId: 'PCI-8.5', scfId: 'SCF-IAM-008', ref: 'Req 8.5' },
    { externalId: 'PCI-8.6', scfId: 'SCF-IAM-005', ref: 'Req 8.6' },

    // ── Requirement 9 — Restrict Physical Access to Cardholder Data ──────
    { externalId: 'PCI-9.1', scfId: 'SCF-PHY-001', ref: 'Req 9.1' },
    { externalId: 'PCI-9.2', scfId: 'SCF-PHY-002', ref: 'Req 9.2' },
    { externalId: 'PCI-9.3', scfId: 'SCF-PHY-004', ref: 'Req 9.3' },
    { externalId: 'PCI-9.4', scfId: 'SCF-PHY-010', ref: 'Req 9.4' },
    { externalId: 'PCI-9.5', scfId: 'SCF-PHY-015', ref: 'Req 9.5' },

    // ── Requirement 10 — Log and Monitor All Access ──────────────────────
    { externalId: 'PCI-10.1', scfId: 'SCF-OPS-006', ref: 'Req 10.1' },
    { externalId: 'PCI-10.2', scfId: 'SCF-OPS-006', ref: 'Req 10.2' },
    { externalId: 'PCI-10.3', scfId: 'SCF-OPS-006', ref: 'Req 10.3' },
    { externalId: 'PCI-10.4', scfId: 'SCF-OPS-007', ref: 'Req 10.4' },
    { externalId: 'PCI-10.5', scfId: 'SCF-OPS-006', ref: 'Req 10.5' },
    { externalId: 'PCI-10.6', scfId: 'SCF-OPS-008', ref: 'Req 10.6' },
    { externalId: 'PCI-10.7', scfId: 'SCF-OPS-007', ref: 'Req 10.7' },

    // ── Requirement 11 — Test Security of Systems and Networks ──────────
    { externalId: 'PCI-11.1', scfId: 'SCF-OPS-007', ref: 'Req 11.1' },
    { externalId: 'PCI-11.2', scfId: 'SCF-OPS-007', ref: 'Req 11.2' },
    { externalId: 'PCI-11.3', scfId: 'SCF-AUD-004', ref: 'Req 11.3' },
    { externalId: 'PCI-11.4', scfId: 'SCF-AUD-003', ref: 'Req 11.4' },
    { externalId: 'PCI-11.5', scfId: 'SCF-OPS-007', ref: 'Req 11.5' },
    { externalId: 'PCI-11.6', scfId: 'SCF-DEV-011', ref: 'Req 11.6' },

    // ── Requirement 12 — Support Information Security with Policies ──────
    { externalId: 'PCI-12.1', scfId: 'SCF-GOV-001', ref: 'Req 12.1' },
    { externalId: 'PCI-12.2', scfId: 'SCF-AST-002', ref: 'Req 12.2' },
    { externalId: 'PCI-12.3', scfId: 'SCF-RSK-001', ref: 'Req 12.3' },
    { externalId: 'PCI-12.4', scfId: 'SCF-GOV-004', ref: 'Req 12.4' },
    { externalId: 'PCI-12.5', scfId: 'SCF-OPS-012', ref: 'Req 12.5' },
    { externalId: 'PCI-12.6', scfId: 'SCF-PPL-003', ref: 'Req 12.6' },
    { externalId: 'PCI-12.7', scfId: 'SCF-PPL-001', ref: 'Req 12.7' },
    { externalId: 'PCI-12.8', scfId: 'SCF-VDR-001', ref: 'Req 12.8' },
    { externalId: 'PCI-12.9', scfId: 'SCF-VDR-002', ref: 'Req 12.9' },
    { externalId: 'PCI-12.10', scfId: 'SCF-INC-001', ref: 'Req 12.10' },
  ],
};

module.exports = {
  FRAMEWORK_PCI_DSS,
};
